import React, { useEffect, useMemo, useState } from "react";
import { styled } from "@mui/material/styles";
import { InternalStandardProps } from "@mui/material";
import { AppHeader } from "JS/React/Components/AppHeader";
import { useRouting } from "JS/React/Hooks/Routes";
import { useNavigate } from "react-router-dom";
import {
    useCourseDownloadedStatus,
    useDownloadedCourses,
} from "JS/React/Hooks/DownloadCourses";
import { useGlobalCourses } from "JS/React/Hooks/Course/Course";
import { InfiniteScrollManager } from "JS/React/Container/InfiniteScrollManager";
import { OfflineCourseList } from "./Components/OfflineCourseList";

const Root = styled("div")(({ theme }) => ({}));

export interface CoursesProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {}

export const OfflineCourses = (props: CoursesProps) => {
    const { className, ...rest } = props;
    const { userDownloadedCourses } = useDownloadedCourses();
    const { isCourseDownloaded } = useCourseDownloadedStatus();
    const { linkProvider } = useRouting();
    const navigate = useNavigate();

    const { courses } = useGlobalCourses();
    const [searchQuery, setSearchQuery] = useState("");

    const allCourses = useMemo(() => {
        const viewOnlyCourses = courses
            ? courses.filter((course) => !isCourseDownloaded(course?.nid))
            : [];

        return [...userDownloadedCourses, ...viewOnlyCourses];
    }, [userDownloadedCourses, courses]);

    const searchResults = useMemo(() => {
        return allCourses?.filter(
            (d) =>
                d?.title
                    ?.toLocaleLowerCase()
                    ?.includes(searchQuery.toLocaleLowerCase().trim()) ||
                d?.description
                    ?.toLocaleLowerCase()
                    ?.includes(searchQuery.toLocaleLowerCase().trim()),
        );
    }, [allCourses, searchQuery]);

    const finalData = useMemo(() => searchResults, [searchResults]);

    useEffect(() => {
        if (searchQuery !== "") {
            window.scrollTo(0, 500);
            window.scrollTo(0, 0);
        }
    }, []);

    return (
        <Root {...rest} className={className}>
            <AppHeader
                title="Courses"
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                searchPlaceholder={"Search Courses by title/description"}
                canGoBack
                onBackClick={() => {
                    navigate(linkProvider.react.home());
                }}
            />
            <InfiniteScrollManager>
                <OfflineCourseList downloadedCourses={finalData} />
            </InfiniteScrollManager>
        </Root>
    );
};
